import { useEffect, useRef } from 'react';
import lottie from 'lottie-web/build/player/lottie_light';
import animationData from '../assets/deskey-loader.json';

/**
 * Branded loading animation — same Lottie file as the teacher mobile app's
 * Loader (teacher-mobile/assets/deskey-loader.json). Use for a page or section
 * waiting on data; keep small spinners inside buttons and skeletons for lists.
 * `fullscreen` fills the viewport (app start, blocking work) instead of sitting inline.
 */
export default function Loader({ label, fullscreen = false, size, className = '' }) {
  const boxRef = useRef(null);
  const dim = size ?? (fullscreen ? 160 : 96);
  useEffect(() => {
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const anim = lottie.loadAnimation({
      container: boxRef.current, renderer: 'svg', loop: true, autoplay: !reduceMotion, animationData,
    });
    return () => anim.destroy();
  }, []);
  return (
    <div role="progressbar" aria-label={label ?? 'Loading'} data-testid="loader"
      className={`flex flex-col items-center justify-center ${fullscreen ? 'min-h-screen bg-white' : 'py-8'} ${className}`}>
      <div ref={boxRef} style={{ width: dim, height: dim }} aria-hidden="true" />
      {label ? <p className="mt-1 text-sm text-zinc-500">{label}</p> : null}
    </div>
  );
}
